export default function(that) {
  const fallbackNamespace = 'reviewshake';
  const namespace = that ? that.namespace : fallbackNamespace;
  return namespace || fallbackNamespace;
}
